import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';
import { KioskPageComponent } from './pages/kiosk-page/kiosk-page.component';
import { KioskBirthdayComponent } from './components/kiosk-birthday/kiosk-birthday.component';
import { GeneralModule } from '../general/general.module';
import { TranslateModule } from '@ngx-translate/core';
import { KioskMainPageComponent } from './components/kiosk-main-page/kiosk-main-page.component';
import { BookingModule } from '../booking/booking.module';
import { InlineSVGModule } from 'ng-inline-svg';
import { KioskStateService } from './services/kiosk-state.service';
import { PartnerModule } from '../partner/partner.module';
import { KioskChildManagementComponent } from './components/kiosk-child-management/kiosk-child-management.component';
import { KioskAddChildButtonComponent } from './components/kiosk-add-child-button/kiosk-add-child-button.component';
import { KioskEventProductComponent } from './components/kiosk-event-product/kiosk-event-product.component';
import { KisokAdvancedProductsComponent } from './components/kisok-advanced-products/kisok-advanced-products.component';
import { KisokLoginRegisterComponent } from './components/kisok-login-register/kisok-login-register.component';
import { KioskSlotsGuard } from './guards/kiosk-slots.guard';
import { KioskEventProductsGuard } from './guards/kiosk-event-products.guard';
import { KioskAdvancedProductsGuard } from './guards/kiosk-advanced-products.guard';
import { KioskLoginGuard } from './guards/kisok-login.guard';
import { LoginModule } from '../login/login.module';
import { KioskNewChildComponent } from './components/kiosk-new-child/kiosk-new-child.component';
import { KioskEditChildComponent } from './components/kiosk-edit-child/kiosk-edit-child.component';
import { KioskThankYouComponent } from './components/kiosk-thank-you/kiosk-thank-you.component';
import { KioskOrderRegistrationComponent } from './components/kiosk-order-registration/kiosk-order-registration.component';
import { KioskOrderCompleteComponent } from './components/kiosk-order-complete/kiosk-order-complete.component';
import { KioskOrderCompleteGuard } from './guards/kisok-order-complete.guard';
import { KioskGuard } from './guards/kiosk.guard';
import { CameraModule } from '../camera/camera.module';



const routes: Routes = [
  {
    path: 'kiosk',
    canActivate: [KioskGuard],
    component: KioskPageComponent,
    children: [
      {
        path: '',
        children: [
          {
            path: 'partner-registration',
            loadChildren: () => import('../partner-registration/partner-registration.module').then(m => m.PartnerRegistrationModule)
          },
          // {
          //   path: 'registration/childmanagement',
          //   component: KioskChildManagementComponent,
          //   data: { title: ['NAME COMPANY', 'Add Child'] },
          //   children: [
          //     {
          //       path: '',
          //       component: KioskAddChildButtonComponent,
          //     },
          //     {
          //       path: 'new',
          //       component: KioskNewChildComponent,
          //     },
          //     {
          //       path: 'edit',
          //       component: KioskEditChildComponent,
          //     },
          //   ]
          // },
          {
            path: 'registration/thank_you',
            component: KioskThankYouComponent,
          },
          // {
          //   path: 'birthday',
          //   component: KioskBirthdayComponent,
          //   canActivate: [KioskSlotsGuard],
          //   data: {
          //     title: ['NAME COMPANY', 'Birthday'],
          //     breadcrumb: { title: 'When', sequence: 1, url: '/kiosk/birthday' }
          //   },
          // },
          // {
          //   path: 'event-products',
          //   component: KioskEventProductComponent,
          //   canActivate: [KioskEventProductsGuard],
          //   data: {
          //     title: ['NAME COMPANY', 'Products'],
          //     breadcrumb: { title: 'Who', sequence: 2, url: '/kisok/event-products' }
          //   },
          // },
          // {
          //   path: 'advanced-product',
          //   component: KisokAdvancedProductsComponent,
          //   canActivate: [KioskAdvancedProductsGuard],
          //   data: {
          //     title: ['NAME COMPANY', 'Select Your Extras'],
          //     breadcrumb: { title: 'With Which', sequence: 3, url: '/kiosk/advanced-product' }
          //   },
          // },
          {
            path: 'login',
            component: KisokLoginRegisterComponent,
            canActivate: [KioskLoginGuard],
          },
          // {
          //   path: 'order-register',
          //   component: KioskOrderRegistrationComponent,
          //   canActivate: [KioskLoginGuard],
          //   data: {
          //     title: ['NAME COMPANY', 'Register'],
          //     breadcrumb: { title: 'Login', sequence: 4, url: '/kiosk/order-register' }
          //   },
          // },
          // {
          //   path: 'order-complete',
          //   component: KioskOrderCompleteComponent,
          //   canActivate: [KioskOrderCompleteGuard],
          //   data: {
          //     title: ['NAME COMPANY', 'Complete'],
          //   },
          // },
          {
            path: '',
            component: KioskMainPageComponent,
          },
          {
            path: '**',
            redirectTo: '/kiosk',
            pathMatch: 'full'
          },
        ]
      }
    ]
  },
];


@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    TranslateModule,
    InlineSVGModule,
    GeneralModule,
    BookingModule,
    PartnerModule,
    LoginModule,
    CameraModule,
  ],
  declarations: [
    KioskPageComponent,
    KioskBirthdayComponent,
    KioskMainPageComponent,
    KioskChildManagementComponent,
    KioskAddChildButtonComponent,
    KioskEventProductComponent,
    KisokAdvancedProductsComponent,
    KisokLoginRegisterComponent,
    KioskNewChildComponent,
    KioskEditChildComponent,
    KioskThankYouComponent,
    KioskOrderRegistrationComponent,
    KioskOrderCompleteComponent,
  ],
  providers: [
    KioskStateService,
    KioskSlotsGuard,
    KioskEventProductsGuard,
    KioskAdvancedProductsGuard,
    KioskLoginGuard,
    KioskOrderCompleteGuard,
    KioskGuard,
  ],
})
export class KioskModule { }
